module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-global-sil-container"
  }, [_c('div', {
    staticClass: "loading-global-sil"
  }), _c('div', {
    staticClass: "cargando-text",
    attrs: {
      "id": "loading-global-sil-text"
    }
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8fc792","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Cargando.vue
// module id = 867
// module chunks = 0